export default __webpack_public_path__ + "static/media/Avtosepka1.1.afc6a887.png";